import { render, staticRenderFns } from "./AforoAcces.vue?vue&type=template&id=ce904760&"
import script from "./AforoAcces.vue?vue&type=script&lang=js&"
export * from "./AforoAcces.vue?vue&type=script&lang=js&"
import style0 from "./AforoAcces.vue?vue&type=style&index=0&id=ce904760&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports